/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spellcheck_Accept_All_TitleInputs */



/**
* | output |
* | --- |
* | "Accept All" |
*
* @param {Spellcheck_Accept_All_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_accept_all_title = /** @type {((inputs?: Spellcheck_Accept_All_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_Accept_All_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tout accepter")
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle akzeptieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Accetta tutto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Принять все")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aceptar todo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("全部接受")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すべて受け入れる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सभी स्वीकृत")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aceitar tudo")
	return /** @type {LocalizedString} */ ("Accept All")
});